export const ApiRoutes = {
    VERIFY_STORE: {
        service: "/retailer/ecommerceapi",
        url: "/verifyStore",
        method: "GET",
        authenticate: false
    },
    CATEGORY_LIST: {
        service: "/retailer/ecommerceapi",
        url: "/getCategory",
        method: "GET",
        authenticate: false
    },
    PRODUCTS_LIST: {
        service: "/retailer/ecommerceapi",
        url: "/getProducts",
        method: "POST",
        authenticate: false
    },
    PRODUCT_DETAIL: {
        service: "/retailer/ecommerceapi",
        url: "/getProductDetails",
        method: "GET",
        authenticate: false
    },
    SHIPPING_TIME: {
        service: "/retailer/ecommerceapi",
        url: "/getShippingRate",
        method: "POST",
        authenticate: false
    },
    TAX_AND_DISCOUNT: {
        service: "/retailer/ecommerceapi",
        url: "/taxAndDiscount",
        method: "POST",
        authenticate: false
    },
    SIGNUP: {
        service: "/retailer/ecommerceAuthApi",
        url: "/signupCustomer",
        method: "POST",
        authenticate: false
    },
    LOGIN: {
        service: "/retailer/ecommerceAuthApi",
        url: "/loginWithPassword",
        method: "POST",
        authenticate: false
    },
    USER_PROFILE: {
        service: "/retailer/ecommerceAuthApi",
        url: "/getCustomerUserProfile",
        method: "GET",
        authenticate: true
    },
    UPDATE_PROFILE: {
        service: "/retailer/ecommerceAuthApi",
        url: "/updateCustomer",
        method: "POST",
        authenticate: true
    },
    COUNTRY_LIST: {
        service: "/retailer/ecommerceAuthApi",
        url: "/countryList",
        method: "GET",
        authenticate: false
    },
    STATE_LIST: {
        service: "/retailer/ecommerceAuthApi",
        url: "/stateList",
        method: "POST",
        authenticate: false
    },
    CITY_LIST: {
        service: "/retailer/ecommerceAuthApi",
        url: "/cityList",
        method: "POST",
        authenticate: false
    },
    LOGOUT: {
        service: "/retailer/ecommerceAuthApi",
        url: "/logOut",
        method: "POST",
        authenticate: true
    },
    CHANGE_PASSWORD: {
        service: "/retailer/ecommerceAuthApi",
        url: "/changePassword",
        method: "POST",
        authenticate: true
    },
    FORGOT_PASSWORD: {
        service: "/retailer/ecommerceAuthApi",
        url: "/forgotPassword",
        method: "POST",
        authenticate: false
    },
    RESET_PASSWORD: {
        service: "/retailer/ecommerceAuthApi",
        url: "/changeForgotPassword",
        method: "POST",
        authenticate: false
    },
    SHIPPINGRATE_TIME: {
        service: "/retailer/ecommerceapi",
        url: "/getShippingDetail",
        method: "POST",
        authenticate: false
    },
    ORDER_LIST: {
        service: "/retailer/ecommerceAuthApi",
        url: "/getOrderList",
        method: "POST",
        authenticate: true
    },
    ORDER_DETAIL: {
        service: "/retailer/ecommerceAuthApi",
        url: "/orderDetail",
        method: "POST",
        authenticate: true
    },
    ORDER_PLACE: {
        service: "/retailer/ecommerceapi",
        url: "/paymentAccept",
        method: "POST",
        authenticate: true
    },
    DOWNLOAD_INVOICE: {
        service: "/retailer/ecommerceAuthApi",
        url: "/donwnloadInvoice/",
        method: "GET",
        authenticate: true
    },
    CHECK_GIFT_CARD_BALANCE: {
        service: "/retailer/ecommerceapi",
        url: "/checkGiftCardBalance/",
        method: "POST",
        authenticate: true
    },
    LOCAL_AREA_LIST: {
        service: "/retailer/ecommerceAuthApi",
        url: "/localAreaList",
        method: "POST",
        authenticate: false
    },
}